import React from "react";
import { generateCRUDRoutes } from "../../../utils/index";
import EmployeeDocuments from "./index";
import { MODULE_MY_DOCS } from "variables/modules";
import { displayIcon } from "variables/icons";

const employeeDocumentsRoutes = [	
    generateCRUDRoutes({
        mainTitle: "My Documents",
        basePath: "documents",
        mainComponent: <EmployeeDocuments />,
        layout: "/console",
        icon: displayIcon("FileText", "icon-item"),
        subTitle:"My Document",
        level:5,
        moduleId: MODULE_MY_DOCS,
    })
];

export default employeeDocumentsRoutes;